interface ICopyToClipboardParams {
    text: string
    onSuccess: () => void
    onError?: () => void
}

export function copyToClipboard({ text, onSuccess, onError }: ICopyToClipboardParams) {
    let textarea
    let result

    if (!navigator.clipboard) {
        try {
            textarea = document.createElement('textarea')
            textarea.setAttribute('readonly', 'true')
            textarea.setAttribute('contenteditable', 'true')
            textarea.style.position = 'fixed' // prevent scroll from jumping to the bottom when focus is set.
            textarea.value = text

            document.body.appendChild(textarea)

            textarea.focus()
            textarea.select()

            const range = document.createRange()
            range.selectNodeContents(textarea)

            const sel = window.getSelection()
            sel?.removeAllRanges()
            sel?.addRange(range)

            textarea.setSelectionRange(0, textarea.value.length)
            result = document.execCommand('copy')

            if (result) {
                onSuccess()
            }
        } catch (err) {
            // biome-ignore lint/suspicious/noConsole: intentional error logging
            console.error(err)
            result = null

            onError?.()
        } finally {
            if (textarea) document.body.removeChild(textarea)
        }
    } else {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                onSuccess()
            })
            .catch(() => {
                onError?.()
            })
    }
}
